var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{ref:"btn",staticClass:"btn font-weight-bold px-6",class:[_vm.activeClass, `btn-${_vm.size}`],attrs:{"pill":_vm.pill,"variant":_vm.variant},on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.$t(`button.${_vm.text}`))+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }